import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import './reset.st.css';
import { store } from './store';
import { PostHogProvider } from 'posthog-js/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { App } from 'src/app';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';

import 'react-image-picker-editor/dist/index.css';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
});

const options = {
  api_host: 'https://us.i.posthog.com',
};

const Router = ({ children }) => {
  if (process.env.NODE_ENV === 'production' && process.env.BASE_PATH) {
    return <BrowserRouter basename={process.env.BASE_PATH || ''}>{children}</BrowserRouter>;
  } else {
    return <HashRouter>{children}</HashRouter>;
  }
};

// ? ({ children }) => <BrowserRouter basename={process.env.BASE_PATH || ''}>{children}</BrowserRouter>
// : ({ children }) => <HashRouter>{children}</HashRouter>;

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.GOOGLE_LOGIN_CLIENT_ID}>
      <PostHogProvider apiKey={'phc_u01z3K1wVbueFibuCR077uvWmRehwiUxVHL3TNg0Jqm'} options={options}>
        <Provider store={store}>
          <PrimeReactProvider>
            <Router>
              <App />
            </Router>
          </PrimeReactProvider>
        </Provider>
      </PostHogProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
